import { axiosInstance, handleResponse, handleError } from '../helpers';
import { api } from '../constants'

export const userService = {
    login,
    validateopt,
    logout,
    updatePassword,
    forgotPassword
};

function rejectIfNoAuthToken(user, fallbackMessage) {
    if (user?.data?.token) {
        return user;
    }
    const message =
        user?.responseMessage ||
        user?.errorMessage ||
        user?.message ||
        fallbackMessage;
    return Promise.reject(new Error(typeof message === 'string' ? message : fallbackMessage));
}

function persistAuthenticatedUser(user) {
    const expiresAt = Date.now() + (5 * 60 * 60 * 1000);
    const resUserData = {
        ...user,
        expiresAt,
    };
    localStorage.setItem('user', JSON.stringify(resUserData));
    return resUserData;
}

function toServiceError(error) {
    // Interceptor may already reject with a shaped Error (no axios response).
    if (error instanceof Error && (error.alreadyShownToast || error.isSessionEnd || !error.response)) {
        return Promise.reject(error);
    }
    return handleError(error?.response);
}

function login(UserName, Password) {
    const requestOptions = { UserName, Password };
    return axiosInstance.post(api.user.login, requestOptions)
        .then(handleResponse)
        .then((user) => rejectIfNoAuthToken(user, 'Invalid username or password'))
        .then(persistAuthenticatedUser)
        .catch(toServiceError);
}

function validateopt(UserName, LoginOTP) {
    const requestOptions = { UserName, LoginOTP };
    return axiosInstance.post(api.user.validateotp, requestOptions)
        .then(handleResponse)
        .then((user) => rejectIfNoAuthToken(user, 'Invalid OTP. Please try again.'))
        .then(persistAuthenticatedUser)
        .catch(toServiceError);
}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('user');
}

function updatePassword(passwordDetails) {
    return axiosInstance.put(api.user.updatePassword, passwordDetails)
        .then(handleResponse)
        .catch(toServiceError);
}

function forgotPassword(UserName) {
    const requestOptions = { UserName };
    return axiosInstance.post(api.user.forgotPassword, requestOptions)
        .then(handleResponse)
        .catch(toServiceError);
}